import useNAWSurveyAnswer, { Status } from '../../hooks/NAW/useNAWSurveyAnswer/useNAWSurveyAnswer'
import Success from './Success/Success'
import PageList from './PageList/PageList'

export enum PageType {
  INTRO = 'INTRO',
  ARBEITSPLAETZE = 'ARBEITSPLAETZE',
  FLAECHE = 'FLAECHE',
  SUMMARY = 'SUMMARY',
  PROMO = 'PROMO',
}

const NawImmoraum = () => {
  const [survey, update, save, status] = useNAWSurveyAnswer(null)

  if (!survey) return <></>
  return (
    <div>
      {status === Status.READY && <PageList survey={survey} update={update} save={save} />}
      {status === Status.SUCCESS && <Success />}
    </div>
  )
}

export default NawImmoraum
